import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getServices = () => api.get("/services").then((r) => r.data);
export const getService = (id) => api.get(`/services/${id}`).then((r) => r.data);
export const postReview = (payload) => api.post("/reviews", payload).then((r) => r.data);
export const postBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
